import React, { Dispatch, SetStateAction } from 'react';

interface ThemeState {
  theme: string;
  setTheme: Dispatch<SetStateAction<string>>;
}

export const initialThemeState: ThemeState = {
  theme: localStorage.getItem('globalTheme') || 'light',
  /**
   * Function used to update the active theme
   */
  setTheme: () => null,
};

const ThemeContext = React.createContext<ThemeState>(initialThemeState);
export default ThemeContext;
